import { ProgramName } from '@/types/enrollment';
import { ProgramContext } from './Context';

export const getProgramContext = ({ programName }: { programName?: ProgramName }) => {
  const program = programName ?? ProgramName.NONE;
  const context = ProgramContext[program];
  return context;
};
